import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { map } from '@beef/utils';
var explodeTraverseApi = function explodeTraverseApi(api) {
  return map(api, function (handlerApi) {
    return typeof handlerApi === 'function' ? {
      enter: handlerApi
    } : handlerApi;
  });
};
export var VisitorApi = /*#__PURE__*/function () {
  function VisitorApi(visitors, callContext) {
    _classCallCheck(this, VisitorApi);
    this.callContext = callContext;
    _defineProperty(this, "visitors", void 0);
    this.visitors = explodeTraverseApi(visitors);
  }
  _createClass(VisitorApi, [{
    key: "call",
    value: function call(method, path, state) {
      var _this$visitors$method, _this$visitors$method2;
      var methodPath = ['enterChild', 'exitChild'].includes(method) ? path.parent : path;
      if (!methodPath) return;
      // @ts-expect-error Can't fix that right now
      (_this$visitors$method = this.visitors[methodPath.nodeType]) === null || _this$visitors$method === void 0 ? void 0 : (_this$visitors$method2 = _this$visitors$method[method]) === null || _this$visitors$method2 === void 0 ? void 0 : _this$visitors$method2.call(this.callContext, path, state);
    }
  }]);
  return VisitorApi;
}();